import { Dispatch } from 'redux';
import { UserService } from 'services/user.service';

export const getUsers: any = () => async (dispatch: Dispatch, getState: any) => {
  try {
    const isLoading = getState()?.userManagement?.loading;
    if (isLoading) {
      return;
    }
    dispatch({ type: 'GET_USERS_LOADING' });
    const res = await UserService.getUsers();
    dispatch({ type: 'GET_USERS_SUCCESS', payload: res.value });
  } catch (error) {
    dispatch({ type: 'GET_USERS_ERROR' });
  }
};

export const createUser: any = (payload: any) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: 'CREATE_USER_LOADING' });
    const res = await UserService.createUser(payload);
    dispatch({ type: 'CREATE_USER_SUCCESS', payload: res.value });
    return res.value;
  } catch (error) {
    dispatch({ type: 'CREATE_USER_ERROR' });
    throw error;
  }
};

export const updateUser: any = (payload: any) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: 'UPDATE_USER_LOADING' });
    const res = await UserService.updateUser(payload);
    dispatch({ type: 'UPDATE_USER_SUCCESS', payload: res.value });
    return res.value;
  } catch (error) {
    dispatch({ type: 'UPDATE_USER_ERROR' });
    throw error;
  }
};

export const deleteUser: any = (userId: string, email: string) => async (dispatch: Dispatch) => {
  try {
    dispatch({ type: 'DELETE_USER_LOADING' });
    await UserService.deleteUser({ userId : userId, email: email });
    dispatch({ type: 'DELETE_USER_SUCCESS', payload: userId });
  } catch (error) {
    dispatch({ type: 'DELETE_USER_ERROR' });
    throw error;
  }
};

export const getRoles: any = () => async (dispatch: Dispatch, getState: any) => {
  try {
    const state = getState()?.userManagement?.roles;
    const existing = state?.data;
    const loading = state?.loading;
    if (loading) {
      return existing;
    }
    if (existing && Array.isArray(existing) && existing.length > 0) {
      return existing;
    }
    dispatch({ type: 'GET_ROLES_LOADING' });
    const res = await UserService.getRoles();
    dispatch({ type: 'GET_ROLES_SUCCESS', payload: res.value });
    return res.value;
  } catch (error) {
    dispatch({ type: 'GET_ROLES_ERROR' });
    throw error;
  }
};
